interface IProps {
    age: number,
    className?: string
}

const ClassificationIcon = ({age, className}: IProps) => {
    return (
        <>
            {age === 7 && <div className={`bg-blue-500 aspect-square flex items-center justify-center rounded-sm font-bold w-6 ${className}`}>7</div>}
            {age === 12 && <div className={`bg-green-500 aspect-square flex items-center justify-center rounded-sm font-bold w-6 ${className}`}>12</div>}
            {age === 16 && <div className={`bg-orange-400 aspect-square flex items-center justify-center rounded-sm font-bold w-6 ${className}`}>16</div>}
            {age === 18 && <div className={`bg-red-500 aspect-square flex items-center justify-center rounded-sm font-bold w-6 ${className}`}>18</div>}
        </>
    );
};

export default ClassificationIcon;